/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { fetchThicknessCount, fetchWallThicknessAlertsData } from "../../../api/alertsApi";
import { toast } from "react-toastify";


function useGetWtAlertsData(filter,pageSize,currentPage,order_by,order_dir, refreshToggle, isTokenReady) {
    const [data, setData] = useState({
        alertsList: [],
        alertsCount: 0
    });

    const offset = (currentPage - 1) * pageSize;
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    useEffect(() => {
        if (isTokenReady){

            setLoading(true);
            Promise.all([
                fetchWallThicknessAlertsData(filter, pageSize, offset, order_by, order_dir),
                fetchThicknessCount(filter)
            ]).then(([alertsList, alertsCount]) => {
                setData({
                    alertsList,
                    alertsCount
                });
                setLoading(false);
            }).catch((error) => {
                console.error(error);
                toast.error(`Cannot fetch WT Corrosion Alerts List`);
                setError(error);
            })
        }

    }, [currentPage, order_by, order_dir, filter, refreshToggle, isTokenReady]);

    return { data, loading, error };
}


export default useGetWtAlertsData;